export const getDefaultState = () => {
  return {
    estimateLink: {
      guidLinkMaps: []
    },
    estimateLinkLookups: {
      jobOperationStatusesMap: {}
    },
    unit: {},
    paymentLink: null
  };
};

export default {
  ...getDefaultState()
};
